const t=":host{display:flex;flex-direction:var(--cds-toggle-button-set-direction, row);gap:var(--cds-toggle-button-set-button-space, 12px)}";export{t as default};
